import _ from 'lodash'
import {normalizeComparableString} from '@eitje/utils'

const normalizeSortValue = (item, field) => {
	const val = _.get(item, field)

	if (_.isString(val)) return normalizeComparableString(val)

	return val
}

export const sortRecords = (items, sortDefinition) => {
	if (_.isFunction(sortDefinition)) return _.orderBy(items, sortDefinition)

	const sortRules = _.isArray(sortDefinition) ? sortDefinition : [sortDefinition]

	const sortValueGetters = sortRules.map(sortRule => {
		const field = _.isPlainObject(sortRule) ? sortRule.field : sortRule
		return item => normalizeSortValue(item, field)
	})

	const orders = sortRules.map(sortRule => {
		return sortRule?.direction || 'asc'
	})

	return _.orderBy(items, sortValueGetters, orders)
}
